export enum MealType {
  INDIVIDUAL = 'INDIVIDUAL',
  MORNINGSNACK = 'MORNINGSNACK',
  BREAKFAST = 'BREAKFAST',
  SNACK = 'SNACK',
  LUNCH = 'LUNCH',
  COFFEE = 'COFFEE',
  DINNER = 'DINNER',
  LATESNACK = 'LATESNACK',
  NIGHTSNACK = 'NIGHTSNACK',
}
